/* =============================================================
   THE PEANUT VAN — theme interactivity (vanilla JS, no deps)
   Sticky header, mobile nav drawer, search, dropdown, accordion,
   Shopify AJAX cart (add / change / remove), product form,
   quantity steppers, product gallery, toast.
   ============================================================= */
(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var routes = (window.Shopify && window.Shopify.routes) || { root: "/" };
  function url(path) { return (routes.root || "/").replace(/\/$/, "") + path; }

  /* ---------- Money formatting (Shopify) ---------- */
  var moneyFormat = (window.PeanutVan && window.PeanutVan.moneyFormat) || "${{amount}}";
  function formatMoney(cents) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(dp) { return (Math.abs(cents) / 100).toFixed(dp); }
    function thousands(num, sep) {
      return num.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + (sep || ","));
    }
    var match = moneyFormat.match(placeholderRegex);
    var token = match ? match[1] : "amount";
    switch (token) {
      case "amount": value = thousands(defaultTo(2)); break;
      case "amount_no_decimals": value = thousands(defaultTo(0)); break;
      case "amount_with_comma_separator": value = defaultTo(2).replace(".", ",").replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1."); break;
      case "amount_no_decimals_with_comma_separator": value = thousands(defaultTo(0), "."); break;
      case "amount_with_space_separator": value = thousands(defaultTo(2), " "); break;
      default: value = thousands(defaultTo(2));
    }
    return moneyFormat.replace(placeholderRegex, value);
  }

  /* ---------- Sticky header shadow ---------- */
  var header = $("#siteHeader");
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 8) header.classList.add("is-stuck");
      else header.classList.remove("is-stuck");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Overlay + panels ---------- */
  var overlay = $("#overlay");
  var drawer = $("#mobileDrawer");
  var cart = $("#cartDrawer");
  var lastFocus = null;
  function lockScroll(on) { document.body.style.overflow = on ? "hidden" : ""; }

  function closeAll() {
    if (drawer) { drawer.classList.remove("is-open"); drawer.setAttribute("aria-hidden", "true"); }
    if (cart) { cart.classList.remove("is-open"); cart.setAttribute("aria-hidden", "true"); }
    if (overlay) overlay.classList.remove("is-open");
    var mo = $("#menuOpen"); if (mo) mo.setAttribute("aria-expanded", "false");
    var co = $("#cartOpen"); if (co) co.setAttribute("aria-expanded", "false");
    lockScroll(false);
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} lastFocus = null; }
  }
  function openDrawer() {
    if (!drawer) return;
    lastFocus = $("#menuOpen");
    drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false");
    if (overlay) overlay.classList.add("is-open"); lockScroll(true);
    if (lastFocus) lastFocus.setAttribute("aria-expanded", "true");
    var first = drawer.querySelector("a,button"); if (first) first.focus();
  }
  function openCart() {
    if (!cart) return;
    lastFocus = $("#cartOpen");
    cart.classList.add("is-open"); cart.setAttribute("aria-hidden", "false");
    if (overlay) overlay.classList.add("is-open"); lockScroll(true);
    if (lastFocus) lastFocus.setAttribute("aria-expanded", "true");
    var c = $("#cartClose"); if (c) c.focus();
  }
  if (overlay) overlay.addEventListener("click", closeAll);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
  var el;
  if ((el = $("#menuOpen"))) el.addEventListener("click", openDrawer);
  if ((el = $("#menuClose"))) el.addEventListener("click", closeAll);
  if ((el = $("#cartClose"))) el.addEventListener("click", closeAll);

  /* Cart trigger: open drawer on home/collections; on cart page just follow the link */
  var cartOpen = $("#cartOpen");
  if (cartOpen) {
    cartOpen.addEventListener("click", function (e) {
      if (cart) { e.preventDefault(); openCart(); }
    });
  }

  /* ---------- Header search toggle ---------- */
  var searchToggle = $("#searchToggle");
  var headerSearch = $("#headerSearch");
  if (searchToggle && headerSearch) {
    searchToggle.addEventListener("click", function () {
      var open = headerSearch.classList.toggle("is-open");
      searchToggle.setAttribute("aria-expanded", String(open));
      if (open) { var i = $("#siteSearch"); if (i) setTimeout(function () { i.focus(); }, 60); }
    });
  }

  /* ---------- Desktop dropdown ---------- */
  var DESKTOP_NAV_MIN = 1100; /* must match the CSS hamburger breakpoint */
  $$("[data-dropdown]").forEach(function (dd) {
    var toggle = $(".dropdown-toggle", dd);
    if (!toggle) return;
    var closeTimer;
    var isDesktop = function () { return window.innerWidth > DESKTOP_NAV_MIN; };
    var setOpen = function (on) {
      dd.setAttribute("data-open", on ? "true" : "false");
      toggle.setAttribute("aria-expanded", String(on));
    };
    var openNow = function () { clearTimeout(closeTimer); setOpen(true); };
    /* grace period so the pointer can travel to the menu without it snapping shut */
    var closeSoon = function (delay) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { setOpen(false); }, delay == null ? 260 : delay);
    };
    toggle.addEventListener("click", function (e) {
      e.stopPropagation();
      clearTimeout(closeTimer);
      setOpen(dd.getAttribute("data-open") !== "true");
    });
    dd.addEventListener("mouseenter", function () { if (isDesktop()) openNow(); });
    dd.addEventListener("mouseleave", function () { if (isDesktop()) closeSoon(); });
    /* keyboard support */
    dd.addEventListener("focusin", function () { if (isDesktop()) openNow(); });
    dd.addEventListener("focusout", function () {
      /* defer: activeElement is briefly <body> mid-transition */
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (!dd.contains(document.activeElement)) setOpen(false);
      }, 0);
    });
    dd.addEventListener("keydown", function (e) {
      if (e.key === "Escape" || e.keyCode === 27) { clearTimeout(closeTimer); setOpen(false); toggle.focus(); }
    });
    document.addEventListener("click", function (e) {
      if (!dd.contains(e.target)) { clearTimeout(closeTimer); setOpen(false); }
    });
  });

  /* ---------- Mobile accordions ---------- */
  $$("[data-accordion]").forEach(function (acc) {
    var btn = $(".m-acc-toggle", acc);
    if (!btn) return;
    btn.addEventListener("click", function () {
      var open = acc.getAttribute("data-open") === "true";
      acc.setAttribute("data-open", open ? "false" : "true");
      btn.setAttribute("aria-expanded", String(!open));
    });
  });

  /* ---------- Toast ---------- */
  var toast = $("#toast"), toastMsg = $("#toastMsg"), toastTimer;
  function showToast(msg) {
    if (!toast) return;
    if (toastMsg) toastMsg.textContent = msg;
    toast.classList.add("is-show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("is-show"); }, 2600);
  }

  /* ---------- Quantity steppers (product + cart) ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty]");
    if (!btn) return;
    var wrap = btn.closest(".qty-stepper");
    var input = wrap && wrap.querySelector("input");
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += (btn.getAttribute("data-qty") === "up" ? 1 : -1);
    if (val < 1) val = 1;
    input.value = val;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------- Cart drawer rendering ---------- */
  var cartItemsEl = $("#cartItems");
  var cartEmptyEl = $("#cartEmpty");
  var cartCountEl = $("#cartCount");
  var cartTotalEl = $("#cartTotal");

  function updateCount(count) {
    if (!cartCountEl) return;
    if (count > 0) { cartCountEl.hidden = false; cartCountEl.textContent = String(count); }
    else { cartCountEl.hidden = true; cartCountEl.textContent = "0"; }
  }

  function renderDrawer(cartData) {
    updateCount(cartData.item_count);
    if (cartTotalEl) cartTotalEl.textContent = formatMoney(cartData.total_price);
    if (!cartItemsEl) return;
    $$(".cart-line", cartItemsEl).forEach(function (n) { n.remove(); });
    if (!cartData.items || cartData.items.length === 0) {
      if (cartEmptyEl) cartEmptyEl.style.display = "";
      return;
    }
    if (cartEmptyEl) cartEmptyEl.style.display = "none";
    cartData.items.forEach(function (it) {
      var line = document.createElement("div");
      line.className = "cart-line";
      var img = it.image
        ? it.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, "_120x120$1$2")
        : "";
      var variant = (it.variant_title && it.variant_title !== "Default Title") ? '<div class="cp">' + it.variant_title + "</div>" : "";
      line.innerHTML =
        '<a href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" width="64" height="64">' : '<span class="ph64"></span>') + "</a>" +
        '<div><div class="ct"><a href="' + it.url + '">' + it.product_title + "</a></div>" +
        variant +
        '<div class="cp">' + it.quantity + " &times; " + formatMoney(it.final_price) + "</div></div>" +
        '<button class="cx" data-remove="' + it.key + '" aria-label="Remove ' + it.product_title + '">&times;</button>';
      cartItemsEl.insertBefore(line, cartEmptyEl);
    });
  }

  function fetchCart() {
    return fetch(url("/cart.js"), { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); });
  }
  function refreshCart() { return fetchCart().then(renderDrawer); }

  /* Remove line (event delegation) */
  document.addEventListener("click", function (e) {
    var rm = e.target.closest("[data-remove]");
    if (!rm) return;
    e.preventDefault();
    changeLine(rm.getAttribute("data-remove"), 0);
  });
  function changeLine(key, qty) {
    return fetch(url("/cart/change.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (data) {
      renderDrawer(data);
      // if on the cart page, reload to reflect totals/rows
      if (document.body.getAttribute("data-template") === "cart") window.location.reload();
      return data;
    });
  }

  /* ---------- Add to cart (product cards + product page) ---------- */
  function bindAddForm(form) {
    form.addEventListener("submit", function (e) {
      // Only intercept when JS is available; graceful fallback posts to /cart/add
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : "";
      if (btn) { btn.setAttribute("disabled", "disabled"); btn.classList.add("is-loading"); }
      var formData = new FormData(form);
      fetch(url("/cart/add.js"), {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: formData
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      }).then(function (res) {
        if (btn) { btn.removeAttribute("disabled"); btn.classList.remove("is-loading"); btn.innerHTML = original; }
        if (!res.ok) {
          showToast(res.data.description || res.data.message || "Sorry, that couldn't be added.");
          return;
        }
        showToast("Added " + (res.data.product_title || "item") + " to cart");
        refreshCart().then(function () { openCart(); });
      }).catch(function () {
        if (btn) { btn.removeAttribute("disabled"); btn.classList.remove("is-loading"); btn.innerHTML = original; }
        showToast("Something went wrong. Please try again.");
      });
    });
  }
  $$("form[data-add-to-cart]").forEach(bindAddForm);

  /* Initial drawer state from server-rendered cart count */
  if (cartItemsEl) refreshCart();

  /* ---------- Product page: variant selection ---------- */
  var productForm = $("[data-product-form]");
  if (productForm) {
    var productData = null;
    try { productData = JSON.parse($("[data-product-json]").textContent); } catch (e) {}
    var idInput = productForm.querySelector('[name="id"]');
    var priceNow = $("[data-price-now]");
    var priceWas = $("[data-price-was]");
    var addBtn = productForm.querySelector('[type="submit"]');

    function currentOptions() {
      return $$("[data-option-index]", productForm).map(function (grp) {
        var checked = grp.querySelector("input:checked");
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      if (!productData) return null;
      return productData.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function updateVariant() {
      var v = findVariant(currentOptions());
      if (!v) {
        if (addBtn) { addBtn.setAttribute("disabled", "disabled"); addBtn.textContent = "Unavailable"; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.innerHTML = formatMoney(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.innerHTML = formatMoney(v.compare_at_price);
          priceWas.hidden = false;
        } else { priceWas.hidden = true; }
      }
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute("disabled"); addBtn.textContent = "Add to Cart"; }
        else { addBtn.setAttribute("disabled", "disabled"); addBtn.textContent = "Sold Out"; }
      }
      // update gallery to variant image
      if (v.featured_image && v.featured_image.src) {
        var main = $("[data-gallery-main] img");
        if (main) main.src = v.featured_image.src;
      }
      // reflect variant in URL
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u.toString());
      }
    }
    $$("[data-option-index] input", productForm).forEach(function (inp) {
      inp.addEventListener("change", updateVariant);
    });
    updateVariant();
  }

  /* ---------- Product gallery thumbnails ---------- */
  $$("[data-gallery-thumb]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      var main = $("[data-gallery-main] img");
      if (main) main.src = thumb.getAttribute("data-full");
      $$("[data-gallery-thumb]").forEach(function (t) { t.setAttribute("aria-current", "false"); });
      thumb.setAttribute("aria-current", "true");
    });
  });

  /* ---------- Video: click-to-play facade ---------- */
  /* Delegated so it also works for sections added in the theme editor. */
  document.addEventListener("click", function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(".video-play") : null;
    if (!btn) return;
    var facade = btn.closest("[data-video-facade]");
    if (!facade || facade.getAttribute("data-loaded") === "true") return;

    var type = facade.getAttribute("data-video-type");
    var id = facade.getAttribute("data-video-id");
    if (!id) return;

    var src;
    if (type === "vimeo") {
      src = "https://player.vimeo.com/video/" + encodeURIComponent(id) + "?autoplay=1&title=0&byline=0";
    } else {
      src = "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(id) + "?autoplay=1&rel=0&playsinline=1";
    }

    var iframe = document.createElement("iframe");
    iframe.setAttribute("src", src);
    iframe.setAttribute("title", btn.getAttribute("aria-label") || "Video");
    iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share");
    iframe.setAttribute("allowfullscreen", "");

    facade.setAttribute("data-loaded", "true");
    facade.innerHTML = "";
    facade.appendChild(iframe);
    if (iframe.focus) iframe.focus();
  });

  /* Close mobile drawer when an in-page anchor is clicked */
  if (drawer) {
    $$("a[href]", drawer).forEach(function (a) {
      a.addEventListener("click", function () {
        if (a.getAttribute("href").charAt(0) === "#") closeAll();
      });
    });
  }
})();
